module.exports = __webpack_public_path__ + "static/images/trash-can-black.d8efe133bde7fd6d65bb17cae86807ee.svg";